module.exports = __webpack_public_path__ + "static/media/earth.51eb20d2.svg";